module.exports = __webpack_public_path__ + "static/media/how-it-works-undercarriage-4.a4bec13c.png";